import { Directive, Input, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[PreventKeys]',
})
export class PreventKeysDirective {
  private regex: RegExp = new RegExp(/^[a-zA-Z0-9 ._-]+$/);
  inputElement: ElementRef;
  // Allow decimal numbers and negative values
  private BlockedKey: Array<string> = ['Tab'];

  @Input('PreventKeys') PreventKeys: string;
  arabicRegex = '[\u0600-\u06FF]';

  constructor(el: ElementRef) {
    this.inputElement = el;
  }

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    if (this.PreventKeys === 'number') {
      this.NumberOnly(event);
    } else if (this.PreventKeys === 'nospecial') {
      this.NoSpecialChars(event);
    } else {
      this.NoSpecialChars(event);
    }
  }

  NumberOnly(event) {
    const e = <KeyboardEvent>event;

    if (this.BlockedKey.indexOf(e.code) !== -1) {
      e.preventDefault();
    }
    if (
      [46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && e.ctrlKey === true) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && e.ctrlKey === true) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && e.ctrlKey === true) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && e.ctrlKey === true)
    ) {
      // let it happen, don't do anything
      return;
    }
    if (
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].indexOf(e.key) === -1
    ) {
      e.preventDefault();
    }
  }

  NoSpecialChars(event) {
    const e = <KeyboardEvent>event;

    if (this.BlockedKey.indexOf(e.code) !== -1) {
      e.preventDefault();
    }
    let k;
    k = event.keyCode; // k = event.charCode;  (Both can be used)
    if (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k === 8 ||
      k === 32 ||
      (k >= 48 && k <= 57) ||
      k == 95 ||
      k == 44 ||
      k == 32
    ) {
      return;
    }
    const ch = String.fromCharCode(e.keyCode);
    const regEx = new RegExp(this.arabicRegex);
    if (regEx.test(ch)) {
      return;
    }
    e.preventDefault();
  }

  IsSpecial(k: number): boolean {
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }
}
